/**
 * Post helpers shared by list/card views.
 *
 * `hasPostBody` returns true only when the post has substantive body
 * HTML (after stripping tags + &nbsp; + whitespace). Custom intros are
 * deliberately NOT counted — the intro is already visible on the card,
 * so a "Read the post" CTA against an empty body would lead nowhere.
 * Used to hide "Read the post" / "Read the memory" CTAs on
 * headline-only posts (e.g. breaking news that the admin will fill in
 * later, or intro-only lead-ins).
 */

export const hasPostBody = (post) => {
  const raw = post?.body;
  if (!raw) return false;
  const stripped = String(raw)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
  return stripped.length > 0;
};
